import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
    minWidth: '1200px',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  contentPaper: {
    margin: '10px !important',
    borderTop: '2px solid #DF0C36',
    width: '100%',
  },
  gridMarginSmall: {
    padding: '5px',
  },
  contentBlocks: {
    margin: '0px !important',
    border: '1px solid #DF0C36',
    borderRadius: '5px',
    width: '100%',
    height: '200px',
    boxShadow: '0px 15px 20px rgb(217 224 221 / 40%)',
  },
  titleBlack: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    lineHeight: '28px',
    alignItems: 'center',
    margin: '20px',
    color: '#666666',
    marginBottom: 7,
  },
  fileDownloadButton: {
    marginTop: '120px ',
    marginBottom: '20px ',
    'text-align': 'center',
    marginRight: '40px ',
    marginLeft: '40px ',
  },
  fileUploadButton: {
    marginTop: '20px ',
    marginBottom: '20px ',
    marginRight: '40px ',
    marginLeft: '40px ',
    'text-align': 'center',
  },
  contentFileUpload: {
    marginTop: '20px ',
    marginBottom: '20px ',
    'text-align': 'center',
  },
  contentCriticityDescription: {
    'text-align': 'left',
    fontStyle: 'normal',
    fontSize: '12px',
    marginLeft: '100px ',
    marginRight: '100px',
  },
}));
